import { FC } from 'react';
import { Button } from '@common/components';
import { Paper, Title, Text, Flex, Group, Space, CloseButton } from '@mantine/core';

import styles from './styles.module.scss';
import { setWidgetInstructionStatus } from 'src/helpers/localStorageHelper';
import { apiInstance } from 'src/services';
import { useTranslation } from 'react-i18next';
import { PATHS } from 'src/constants';
import { useNavigate } from 'react-router';
import { useAppSelector } from 'src/store';
import { shallowEqual } from 'react-redux';

interface InstructionAbstractProps {
  title: string;
  description: string;
  button: string;
  onAction?: (param?: any) => void;
  link?: string;
}

const instruction = [
  {
    title: 'instructions.title1',
    description: 'instructions.description1',
    button: 'instructions.button1',
    link: `${PATHS.FAQ}?focusOnInstall=true`,
  },
  {
    title: 'instructions.title2',
    description: 'instructions.description2',
    button: 'instructions.button2',
    link: `${PATHS.FAQ}?focusOnReports=true`,
  },
  {
    title: 'instructions.title3',
    description: 'instructions.description3',
    button: 'instructions.button3',
    onAction: () => {
      apiInstance.get('payment/portal').then((res) => {
        window.location = res.data.url;
      });
    },
  },
];

const InstructionAbstract: FC<InstructionAbstractProps> = ({ title, description, button, onAction }) => {
  return (
    <Flex direction="column" className={styles.abstract}>
      <Title className={styles['second-heading']} order={2}>
        {title}
      </Title>
      <Space h={8} />
      <Text size={14}>{description}</Text>
      <Space h={8} />
      <Group>
        <Button color="gray-light" onClick={onAction} small>
          {button}
        </Button>
      </Group>
      <Space h={24} />
    </Flex>
  );
};

interface WidgetInstructionProps {
  clickAction: () => void;
}

export const WidgetInstruction: FC<WidgetInstructionProps> = ({ clickAction }) => {
  const [t] = useTranslation('widget');
  const navigate = useNavigate();
  const { data } = useAppSelector((state) => state.user, shallowEqual);

  // const hasPermission =   data.profile_status == "user" ? (data.userPermission?.includes('billing') ? true : false )  : true   ;

  return (
    <Paper id="hint-section" className={styles.instruction} p="md" pb={0} radius={8}>
      <Flex justify="flex-end">
        <CloseButton
          aria-label={`${t('close')}`}
          onClick={() => {
            setWidgetInstructionStatus('true');
            clickAction();
          }}
          right={0}
        />
      </Flex>
      {instruction.map((item) => (
        <InstructionAbstract
          key={t(`${item.title}`)}
          onAction={item.link ? () => navigate(item.link) : item.onAction ? () => item.onAction() : undefined}
          title={t(`${item.title}`)}
          description={t(`${item.description}`)}
          button={t(`${item.button}`)}
        />
      ))}
    </Paper>
  );
};
